var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenesysLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 24 40",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    d: "m 13.37211,28.703625 h 4.063876 c 1.418684,0 2.775438,0.551758 3.772773,1.527876 0.996673,0.97549 1.552932,2.294281 1.552932,3.66507 0,1.370953 -0.556259,2.689943 -1.552932,3.665367 -0.997335,0.976084 -2.354089,1.527842 -3.772773,1.527842 H 13.37211 c -1.418716,0 -2.775471,-0.551758 -3.7728064,-1.527842 -0.996672,-0.975424 -1.552899,-2.294414 -1.552899,-3.665367 0,-1.370789 0.556227,-2.68958 1.552899,-3.66507 0.9973354,-0.976118 2.3540904,-1.527876 3.7728064,-1.527876 z",
    stroke: "currentColor",
    strokeWidth: 1.82044,
    id: "path1",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.7044121,12.928978 H 17.040323 c 0.763392,0 1.518873,0.147422 2.223217,0.433429 0.704277,0.286008 1.343052,0.704742 1.880312,1.231443 0.537228,0.526669 0.962382,1.150914 1.252097,1.836623 0.289714,0.685709 0.43856,1.419973 0.43856,2.161056 0,0.741083 -0.148846,1.475349 -0.43856,2.161024 -0.289715,0.685743 -0.714869,1.309987 -1.252097,1.836656 -0.53726,0.526668 -1.176035,0.945402 -1.880312,1.231409 -0.704344,0.286008 -1.459825,0.433463 -2.223217,0.433463 H 6.7044121 c -1.5424726,0 -3.018218,-0.60091 -4.1035227,-1.664872 -1.0846858,-1.0634 -1.69066937,-2.501777 -1.69066937,-3.99768 0,-1.495902 0.60598357,-2.934279 1.69066937,-3.997679 1.0853047,-1.063995 2.5610501,-1.664872 4.1035227,-1.664872 z",
    stroke: "currentColor",
    strokeWidth: 1.82044,
    id: "path2",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.967139,8.479433 c -2.090192,0 -3.784621,-1.694429 -3.784621,-3.784589 0,-2.090195 1.694429,-3.78462397 3.784621,-3.78462397 2.090193,0 3.784622,1.69442897 3.784622,3.78462397 0,2.09016 -1.694429,3.784589 -3.784622,3.784589 z",
    stroke: "currentColor",
    strokeWidth: 1.82044,
    id: "path3",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.435986,27.793407 H 13.37211 c -1.653884,0 -3.240013,0.643011 -4.4094624,1.787603 -1.1694818,1.144591 -1.826461,2.696993 -1.826461,4.315561 0,1.618865 0.6569792,3.1712 1.826461,4.315758 1.1694494,1.144559 2.7555784,1.78767 4.4094624,1.78767 h 4.063876 c 1.653851,0 3.239981,-0.643111 4.409463,-1.78767 1.169448,-1.144558 1.826461,-2.696893 1.826461,-4.315758 0,-1.618568 -0.657013,-3.17097 -1.826461,-4.315561 -1.169482,-1.144592 -2.755612,-1.787603 -4.409463,-1.787603 z",
    fill: "currentColor",
    id: "path4-5",
    style: {
      strokeWidth: 0.330989
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.040323,12.01876 H 6.7044121 c -1.7781033,0 -3.4834224,0.692494 -4.7407318,1.925128 C 0.70635753,15.176523 2.5269699e-6,16.848312 2.5269699e-6,18.591529 c 0,1.743184 0.7063550030301,3.415008 1.9636777730301,4.647642 1.2573094,1.232634 2.9626285,1.925128 4.7407318,1.925128 H 17.040323 c 0.88043,0 1.752253,-0.170028 2.565658,-0.500322 0.813437,-0.330326 1.552535,-0.814463 2.17509,-1.424806 0.622557,-0.610343 1.116392,-1.33491 1.453338,-2.132361 0.336914,-0.79745 0.510318,-1.652129 0.510318,-2.515281 0,-0.863151 -0.173404,-1.717863 -0.510318,-2.515281 -0.336946,-0.79745 -0.830781,-1.52205 -1.453338,-2.13236 -0.622555,-0.610343 -1.361653,-1.09448 -2.17509,-1.424807 -0.813405,-0.330326 -1.685228,-0.500321 -2.565658,-0.500321 z",
    fill: "currentColor",
    id: "path5-2",
    style: {
      strokeWidth: 0.330989
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.272299,4.694844 c 0,-2.592897 2.101943,-4.6948429730301 4.69484,-4.6948429730301 v 0 C 21.560004,1.0269699e-6 23.66198,2.101947 23.66198,4.694844 v 0 c 0,2.592865 -2.101976,4.694808 -4.694841,4.694808 v 0 c -2.592897,0 -4.69484,-2.101943 -4.69484,-4.694808 z",
    fill: "currentColor",
    id: "path6-2",
    style: {
      strokeWidth: 0.330989
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenesysLogo);
export default __webpack_public_path__ + "static/media/genesys-logo.5e992454fd32769f933dcbb4df07dcc0.svg";
export { ForwardRef as ReactComponent };